import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { LocalStorageService } from 'src/app/services/local-storage-service.service';


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  img: string = '';
  interval : any;

  constructor(
    private router: Router,
    private menu: MenuController,
    private _localStorageService: LocalStorageService
  ) { }


  ngOnInit() {
    
    this.interval = setInterval(()=>{
      let d = this._localStorageService.getRestaurantData();
     
      if(d && d.dsLogo){
        this.img = d.dsLogo;
        clearInterval(this.interval)
      }
    }, 1000)
    
    
  } 

  logOut() {
    localStorage.clear()
    this.router.navigate(['/login']);
  }

  goTo(page) {
    this.router.navigate([page]);
    this.menu.close()
  }

}
